import React, {type SVGAttributes} from 'react'

export const PauseIcon = (props: SVGAttributes<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <rect width="7.2" height="24" rx="1" fill="currentColor" />
    <rect x="12.5" width="7.2" height="24" rx="1" fill="currentColor" />
  </svg>
)
